<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
#app {
  font-family: Helvetica, Arial, "PingFang SC", "Microsoft YaHei";
}
.bodyhidden {
  // overflow-y: scroll;
  position: fixed;
  width: 100%;
}
</style>
